import { rtkApi } from 'app/store/AppStore.rtk'
import {
  GamesBySchoolRequest,
  GamesByStateRequest,
  GamesResponse,
  GamesV2Response,
  GamesV3Request,
} from '../Games.model'

export const gamesApi = rtkApi.enhanceEndpoints({ addTagTypes: ['games'] }).injectEndpoints({
  endpoints: (build) => ({
    getGamesByState: build.query<GamesResponse, GamesByStateRequest>({
      query: (request: GamesByStateRequest) => {
        return {
          url: '/games/getForState',
          params: {
            stateId: request.stateId,
            districtId: request.districtId,
            sportId: request.sportId,
            isLeague: request.isLeague,
            leagueId: request.leagueId,
            disableCache: true,
          },
        }
      },
      providesTags: ['games'],
    }),

    getGamesV3: build.query<GamesV2Response, GamesV3Request>({
      query: (request: GamesV3Request) => {
        return {
          url: '/games/v3/getGames',
          method: 'POST',
          body: {
            eventDate: request.date,
            stateIds: request.stateIds,
            districtIds: request.districtIds,
            sportIds: request.sportIds,
            leagueIds: request.leagueIds,
            isLeague: request.isLeague,
            allGames: true,
            countPerSport: request.countPerSport,
            disableCache: true,
          },
        }
      },
      providesTags: ['games'],
    }),

    getGamesBySchool: build.query<GamesResponse, GamesBySchoolRequest>({
      query: (request: GamesBySchoolRequest) => {
        return {
          url: '/games/v3/getForSchools',
          method: 'POST',
          body: {
            stateIds: request.stateIds,
            districtIds: request.districtIds,
            schoolIds: request.schoolIds,
            date: request.date,
            allGames: true,
            countPerSport: request.countPerSport,
            disableCache: true,
          },
        }
      },
      providesTags: ['games'],
    }),
  }),
})

export const { useGetGamesBySchoolQuery, useGetGamesV3Query } = gamesApi
